import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { EventType, Router, RouterLink, RouterLinkActive, RouterOutlet, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AccountInfo } from '@azure/msal-browser';
import { MatSidenavModule } from '@angular/material/sidenav'; 
import { Subject, filter, takeUntil } from 'rxjs';
import { ProtectedRoute } from './common/protectedRouteConfig';
import { AuthService } from './common/services/auth.service';
import { AuthMenuComponent } from './components/auth-menu/auth-menu.component';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { TitleService } from './common/services/title.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
        CommonModule,
        RouterOutlet,
        AuthMenuComponent,
        RouterLink,
        RouterLinkActive,
        MatSidenavModule,
        MatListModule,
        MatIconModule
    ]
})
export class AppComponent {
  title = 'hours-factory';
  user: AccountInfo | null = null;
  ngUnsubscribe = new Subject<void>();
  url = '';
  availableRoutes: ProtectedRoute[] = [];
  isMobileView = false;
  isSidenavOpened = false;

  constructor(
    private ref: ChangeDetectorRef,
    public auth: AuthService,
    public router: Router,
    private breakpointObserver: BreakpointObserver,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService
  ) {
    this.router.events
      .pipe(filter((event) => event.type === EventType.NavigationEnd))
      .subscribe((event) => {
        this.url = this.router.url;
        this.ref.markForCheck();
        
        // Set page title from route data
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        const title = route.snapshot.data['title'];
        this.titleService.setTitle(title);
      });

    this.auth.routes$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((routes) => {
        this.availableRoutes = Object.values(routes);

        this.ref.markForCheck();
      });

      this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
        this.isMobileView = result.matches;
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}